<common-ui-components-filter
  [isActive]="!!restrictions().values().length"
  [size]="'LARGE'"
  (toggleFilter)="handleFilterToggle()"
>
  <ngx-chip
    [id]="'calendar-filter'"
    [leadingIcon]="'Calendar'"
    [disableAnimations]="true"
    [size]="'LARGE'"
    [label]="'بازه زمانی'"
    (click)="handleFilterToggle()"
    [pressed]="false"
    [disableClick]="true"
    [classes]="dateQuickFilterClasses()"
  ></ngx-chip>
  <ngx-chip
    [id]="'charge-filter'"
    [disableAnimations]="true"
    [size]="'LARGE'"
    [disableClick]="true"
    [label]="TransactionTypeGroupsNamesEnum.CHARGE"
    (click)="toggleQuickFilter(TransactionTypeGroupsNamesEnum.CHARGE)"
    [pressed]="false"
    [classes]="chargeQuickFilterClasses()"
  ></ngx-chip>
  <ngx-chip
    [id]="'c2c-filter'"
    [disableAnimations]="true"
    [size]="'LARGE'"
    [disableClick]="true"
    [label]="TransactionTypeGroupsNamesEnum.C2C"
    (click)="toggleQuickFilter(TransactionTypeGroupsNamesEnum.C2C)"
    [pressed]="false"
    [classes]="c2cQuickFilterClasses()"
  ></ngx-chip>
  <ngx-chip
    [id]="'wallet-filter'"
    [disableAnimations]="true"
    [size]="'LARGE'"
    [disableClick]="true"
    [label]="TransactionTypeGroupsNamesEnum.WALLET"
    (click)="toggleQuickFilter(TransactionTypeGroupsNamesEnum.WALLET)"
    [pressed]="false"
    [classes]="walletQuickFilterClasses()"
  ></ngx-chip>
</common-ui-components-filter>

<payment-transactions-grouped-transactions
  (scrolledToEnd)="handleEnd()"
  [isLoading]="isLoading()"
  [pendingTransactions]="pendingTransactions()"
  [transactions]="transactions()"
></payment-transactions-grouped-transactions>
@if (isLoading()) {
  @for (item of rangeCreator(3); track $index) {
    <lib-ngx-skeleton-loading
      [height]="'74px'"
      [classes]="'my-small px-medium radius-medium'"
    ></lib-ngx-skeleton-loading>
  }
}
